<template>
    <v-container fluid grid-list-md>
        <v-layout>
            <v-flex>
                <h1 class="display-3">Operaciones</h1>
            </v-flex>
        </v-layout>
        <v-layout>
            <v-flex>
                <v-text-field label="Desde presupuesto" v-model="d.presuDe"></v-text-field>
            </v-flex>
            <v-flex>
                <v-text-field label="Hasta presupuesto" v-model="d.presuA"></v-text-field>
            </v-flex>
        </v-layout>
        <v-layout>
            <v-flex>
                <v-text-field type="date" label="Desde emision pv" v-model="d.fechaPvDe"></v-text-field>
            </v-flex>
            <v-flex>
                <v-text-field type="date" label="Hasta emision pv" v-model="d.fechaPvA"></v-text-field>
            </v-flex>
        </v-layout>
        <v-layout>
            <v-flex>
                <v-btn @click="datos" :loading="loading">DESCARGAR</v-btn>
            </v-flex>
        </v-layout>
    </v-container>
</template>

<script>
    import {mapActions} from 'vuex';
    import empresaSelect from '../../components/EmpresaSelect.vue';
    import decimales from "../../filters/decimales";
    import saveAs from "file-saver";


    export default {
        name: "operaciones",
        filters: {decimales},
        components: {empresaSelect},
        data() {
            return {
                d: {
                    presuDe: '23800',
                    presuA: '23934',
                    clienteDe: '',
                    clienteA: '',
                    deposito: '',
                    fechaPvDe: '',
                    fechaPvA: ''
                },
                loading: false,
            }
        },
        methods: {
            ...mapActions('notif', ['msjShow']),
            datos() {
                this.loading = true;
                this.$http({
                    method: 'post',
                    url: 'informes/operaciones/datos',
                    data: this.d,
                    headers: {'Content-Type': 'application/json', 'Accept': 'application/vnd.ms-excel'},
                    responseType: "blob"
                })
                    .then((response) => {
                        saveAs(response.data, 'operaciones.xlsx');
                        this.loading = false;
                    })
                    .catch((error) => {
                        alert(error);
                        this.loading = false;
                    });
            },
        }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// resources/assets/js/pages/informes/operaciones.vue